import React from "react";
import logo from "../../../../assets/logo/logo.png";

const Footer = () => {
  return (
    <div>
      <footer className="p-10 bg-primary text-neutral-content">
        <div className="flex items-center justify-center flex-col">
          <img src={logo} className="w-32" alt="" />
          <p>Copyright © 2022 - All right reserved</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
